export default __webpack_public_path__ + "static/media/flexia-logo.98caa2a3.svg";